<template>
  <div id="marquee" style="background-color:white;">
    <img :src="isamnet" style="width:100%" @load="onLoad" />
    <img :src="isamnet" style="width:100%" @load="onLoad" />
    <img :src="isamnet" style="width:100%" @load="onLoad" />
    <img :src="isamnet" style="width:100%" @load="onLoad" />
    <img :src="isamnet" style="width:100%" @load="onLoad" />
    <div
      id="adRoot"
      :style="{
      width: adWidth + 'px',
      height: adHeight + 'px',
      position: 'fixed',
      top: adTop + 'px',
      overflow: 'hidden',
    }">
      <div class="rotatingFerrisWheel" :style="{
        top: '12px',
        right: '9px',
        position: 'absolute',
        display: 'block',
        zIndex: '2',
      }">
        <svg width="14" height="14" style="border: 0px solid black;position: absolute;">
          <circle cx="7" cy="7" r="6" fill="gray" fill-opacity="0.3" stroke="black" stroke-width="0">
          </circle>
          <line x1="3" y1="3" x2="11" y2="11" stroke="black" stroke-width="1.5"></line>
          <line x1="3" y1="11" x2="11" y2="3" stroke="black" stroke-width="1.5"></line>
        </svg>
        <div @click="closeAd()"
          :style="{
            width: '11px',
            height: '11px',
            top: '1.5px',
            right: '1.5px',
            position: 'absolute',
            display: 'block',
            zIndex: '2',
        }"></div>
      </div>
      <div class="ucmarquee-container">
        <div v-for="(img, index) in this.creative.images"
          :key="index"
          :ref="'item-' + index"
          class="ferris-item"
          :style="{
            width: adWidth + 'px',
            height: adHeight + 'px',
            position: 'absolute',
            top: '0px',
          }"
          :class="{
            'currentAd': index == 0,
            'nextAd': index == 1,
            'preAd': index == 2,
          }"
          @transitionend="onTransitionEnd"
        >
          <a :href="getHref(img)" target="_blank">
            <!-- urlBack = 後景：只往下移動，不縮放 -->
            <img
              :src="img.urlBack"
              class="ferris-bg"
              @load="onLoad" />
            <!-- urlFront = 前景：往下移動 2 倍，同時放大 2 倍 -->
            <img
              :src="img.urlFront"
              class="ferris-fg"
              @load="onLoad" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixPreview from '@/components/mixins/preview.js';
import mixMobile from '@/components/mixins/mobile.js';
export default {
  data() {
    return {
      scrollY: window.scrollY,
      loaded: this.creative.images.length + 2,
      adWidth: window.innerWidth,
      adHeight: window.innerWidth / 5 * 2,
      cssHeight: window.innerWidth / 5 * 2 + 'px',
      adTop: window.innerHeight - (window.innerWidth / 5 * 2),
      closeBtnTop: window.innerHeight - (window.innerWidth / 5 * 2),
      isTransition: false,
      isClose: false,
      effectType: this.creative.effectType,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = 'https://cdn.aralego.net/rich_media/assets';
      if (domain === 'prism.amnet.tw') {
        isAmnet += '/amnet/bg3.png';
      } else {
        isAmnet += '/marquee/bg.png';
      }
      return isAmnet;
    },
  },
  methods: {
    handleScroll() {
      if (this.effectType == CONSTANT.ROTATINGFERRISWHELL_TYPE.STOP) {
        return;
      }
      if ((this.scrollY - window.scrollY) > 500 && !this.isTransition && !this.isClose) {
        this.isTransition = true;
        this.scrollY = window.scrollY;
        this.scrollingDown()
      } else if ((this.scrollY - window.scrollY) < -500 && !this.isTransition && !this.isClose) {
        this.isTransition = true;
        this.scrollY = window.scrollY;
        this.scrollingUp();
      }
    },
    handleResize() {
      this.adWidth = window.innerWidth,
      this.adHeight = window.innerWidth / 5 * 2,
      this.adTop = window.innerHeight - (window.innerWidth / 5 * 2);
      this.closeBtnTop = window.innerHeight - (window.innerWidth / 5 * 2);
      // 景深 transform 使用百分比，尺寸更新後自動跟著調整，不需重算
    },
    onTransitionEnd(event) {
      // 景深 transform 在子圖層上，transitionend 從 .ferris-bg / .ferris-fg 冒泡
      if (event.propertyName !== 'transform') {
        return;
      }
      const carouselItem = event.currentTarget;
      if (carouselItem && carouselItem.classList.contains('currentAd')) {
        this.isTransition = false;
      }
    },
    scrollingDown() {
      let adElm = this.getAdElm();
      adElm.preElm.className = 'ferris-item currentAd';
      adElm.curElm.className = 'ferris-item nextAd';
      adElm.nextElm.className = 'ferris-item preAd';
      // 狀態類別已驅動前景／後景的景深 transform
    },
    scrollingUp() {
      let adElm = this.getAdElm();
      adElm.preElm.className = 'ferris-item nextAd';
      adElm.curElm.className = 'ferris-item preAd';
      adElm.nextElm.className = 'ferris-item currentAd';
      // 狀態類別已驅動前景／後景的景深 transform
    },
    getAdElm() {
      let adPicElm = [this.$refs['item-0'], this.$refs['item-1'], this.$refs['item-2']];
      let rv = {
        preElm: null,
        curElm: null,
        nextElm: null,
      };
      adPicElm.forEach(function (item) {
        if (!item || !item[0]) return;
        const className = item[0].className;
        if (className.includes('currentAd')) {
          rv.curElm = item[0]
        } else if (className.includes('nextAd')) {
          rv.nextElm = item[0]
        } else if (className.includes('preAd')) {
          rv.preElm = item[0]
        }
      });
      return rv;
    },
    getHref(image) {
      if (this.creative.useSameLandingPage) {
        return this.creative.landing_page;
      } else {
        return image.landing_page;
      }
    },
    closeAd() {
      let root = document.getElementById('adRoot');
      if (root && root.parentElement) {
        root.parentElement.removeChild(root);
      }
      window.removeEventListener('scroll', this.handleScroll);
      window.parent.removeEventListener('resize', this.handleResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this.handleResize);
      }
      this.isClose = true;
    },
  },
  mixins: [mixPreview, mixMobile],
  mounted() {
    this.viewport();
    window.visualViewport.addEventListener('resize', this.handleResize);
    window.parent.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
};
</script>

<style lang="sass" scoped>
.rotatingFerrisWheel
    margin: auto
    width: 14px
    height: 14px
    right: 0px
    position: fixed
    display: none

.ferris-item
  overflow: hidden
  // 容器本身不再位移，非當前組必須關掉指標事件，否則會蓋住底下的 currentAd
  pointer-events: none

  a
    display: block
    width: 100%
    height: 100%
    position: relative

  // 景深動畫套在前景／後景兩層上，而非整個 item
  // 離場曲線對齊參考 demo；transition 取用切換後狀態，離場落到非 currentAd
  .ferris-bg, .ferris-fg
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    object-fit: cover
    display: block
    transform-origin: center bottom
    transition: transform 1s cubic-bezier(.17, .67, .83, .67)

  // 後景：只往下移動一個 banner 高，不縮放
  .ferris-bg
    z-index: 0
    transform: translateY(100%)

  // 前景：往下移動 2 倍，同時放大 2 倍
  .ferris-fg
    z-index: 1
    transform: translateY(200%) scale(2)

  &.currentAd
    pointer-events: auto

    .ferris-bg
      transform: translateY(0)
      transition: transform 1s ease

    .ferris-fg
      transform: translateY(0) scale(1)
      transition: transform 1s ease
</style>
